import SlideManager from "../utils/slide-manager";

const thetaMax = 2.5 / 180 * Math.PI;
const phiMax = 2.5 / 180 * Math.PI;
const speed = 0.1;

export class MouseHoverRotation {

    constructor(domElement) {
        this.domElement = domElement;
        this.desiredTheta = 0.0;
        this.desiredPhi = 0.0;
        this.currentTheta = 0.0;
        this.currentPhi = 0.0;
        domElement.addEventListener('mousemove', this.onMouseMove.bind(this), false);
        this.time = new Date().getTime();
    }

    onMouseMove(event) {
        const rect = this.domElement.getBoundingClientRect();
        const pos = {
            x: (event.clientX - rect.left) / (rect.right - rect.left) * 2 - 1,
            y: (event.clientY - rect.top) / (rect.bottom - rect.top) * 2 - 1
        };
        this.desiredTheta = pos.x * thetaMax;
        this.desiredPhi = pos.y * phiMax;
    }

    update() {
        if (SlideManager.currentSlide.dynamicPerspective
            && !Q3.editMode
            && SlideManager.currentSlide.controls.interactionType !== "objectRotation"
            && !SlideManager.currentSlide.controls.autoRotate) {

            const time = new Date().getTime();
            let delta = ((time - this.time) / 1000);


            let deltaTheta = (this.desiredTheta - this.currentTheta);
            let deltaPhi = (this.desiredPhi - this.currentPhi);
            while (delta > 0) {
                delta -= 1 / 30;//multiple times if less tha 30 fps
                deltaTheta *= speed;
                deltaPhi *= speed;
            }

            this.currentTheta += deltaTheta
            this.currentPhi += deltaPhi

            this.time = time;
            return {
                theta: -deltaTheta,
                phi: -deltaPhi
            }
        } else {
            return {
                theta: 0,
                phi: 0
            }
        }
    }
}